import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ArticleExport } from '@mp/content-manager/exports/domain';

import { CreateFavoriteListDto, FavoritesList, UpdateFavoriteListDto } from '../models';

export const FavoritesActions = createActionGroup({
  source: 'Content Manager - Favorites',
  events: {
    'Fetch favorites lists': emptyProps(),
    'Fetch favorites lists success': props<{ favoritesLists: FavoritesList[] }>(),
    'Fetch favorites lists error': emptyProps(),

    'Create favorites list': props<{ createDto: CreateFavoriteListDto }>(),
    'Create favorites list success': props<{ createdList: FavoritesList }>(),
    'Create favorites list error': props<{ listName: string }>(),

    'Update favorites list': props<{ listId: string; updateDto: UpdateFavoriteListDto }>(),
    'Update favorites list success': props<{ updatedList: FavoritesList }>(),
    'Update favorites list error': emptyProps(),

    'Update favorites list article count': props<{ listId: string; articleCount: number }>(),

    'Delete favorites list': props<{ listId: string }>(),
    'Delete favorites list success': props<{ listId: string }>(),
    'Delete favorites list error': emptyProps(),

    'Export favorites list': props<{ listId: string; exportType: string }>(),
    'Export favorites list success': props<{ articleExport: ArticleExport }>(),
    'Export favorites list error': emptyProps(),
  },
});
